<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="dishesCheckRecord">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            菜品留样
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">留样添加</el-button>
                    <el-button type="success" :disabled="disabledRemove" @click.native="toggleModalRemove">留样移除</el-button>
                    <el-button type="danger" :disabled="disabledInfo" @click.native="toggleModalInfo">留样详情</el-button>
                    <div style="float:right">
                        <el-select
                            v-model="status"
                            style="margin-right:10px;width:200px">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="dishesType"
                             placeholder="请选择菜品留样类型"
                             clearable
                             style="margin-right:10px;width:200px">
                            <el-option
                                v-for="item in dishesTypeValue"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            value-format='yyyy-MM-dd'
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>
                        <el-table-column prop="time" :formatter="getDate" label="菜品日期"></el-table-column>
                        <el-table-column prop="dishesType" label="存放类别"></el-table-column>
                        <el-table-column prop="startTime" :formatter="getDateTime" label="存放时间"></el-table-column>
                        <el-table-column prop="endTime" :formatter="getDateTime" label="移除时间"></el-table-column>
                        <el-table-column prop="status" :formatter="statusTitle" label="异常状态"></el-table-column>
                        <el-table-column prop="createTime" :formatter="getDateTime" label="创建时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title='留样移除' :visible.sync="batchDialog" @close='closeDialog' width='400px' center top='30vh' :close-on-click-modal='false'>
            <el-date-picker
                ref="picker"
                v-model="endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择留样移除时间"
                :clearable='false'
                :picker-options="pickerOption"
                style="width:100%;margin-right:10px">
            </el-date-picker>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialog=false">取 消</el-button>
                <el-button type="primary"  @click="removeSub">提 交</el-button>
            </div>
        </el-dialog>
        <Add ref="myAdd" v-show="showModalAdd" v-bind:dishesList="dishesList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Add from "./Add";
    import Info from "./Info";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                disabledAdd:true,
                showModalAdd:false,
                showModalInfo:false,
                batchDialog:false,
                showModalEdit:false,
                disabledRemove:true,
                disabledInfo:true,
                searchDishes:'',
                endTime:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                datetimerangeValue:[],
                dishesList:[],
                checkInfo:[],
                status:-1,
                statusValue:[{name:'全部状态',value:-1},{name:'正常',value:0},{name:'禁用',value:1}],
                dishesType:'',
                dishesTypeValue:['早餐','中餐','晚餐'],
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },

            }
        },
        components:{
            Add,Info
        },
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="留样添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                const start= new Date();
                const end=new Date(start.getTime() - 1000 * 60 * 60 * 24 * 15);
                this.datetimerangeValue=[end,start];
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Dishes/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.dishesList=response.data.data
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            closeDialog(){
                this.endTime=''
            },
            removeSub(){
                if(!this.endTime){
                    this.$message.error('请选择留样移除时间')
                    return;
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesCheckRecord/RemoveTime",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        dishesCheckRecordCode:this.checkInfo.dishesCheckRecordCode,
                        endTime:this.endTime,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.batchDialog=false
                        this.getList();
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            toggleModalInfo:function(){
                this.showModalInfo = !this.showModalInfo;
                this.$refs.myInfo.init(this.checkInfo);
            },
            toggleModalRemove:function(){
                let timenow = new Date(this.checkInfo.startTime)
                let limit = function(date){
                    return date.getTime() > Date.now()||timenow- 8.64e7 > date.getTime()
                }
                this.pickerOption.disabledDate = limit
                this.batchDialog=true
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            closeInfo:function(){
                this.showModalInfo =false;
                // this.disabledInfo=true
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "异常";
                }
            },
            getDate(row,index,column){
                return timefilters(column).slice(0,10)
            },
            getDateTime(row,index,column){
                if(column){
                    return timefilters(column)
                }
                return '';
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesCheckRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        dishesType:this.dishesType,
                        status:this.status,
                        startTime:timefilters(this.datetimerangeValue[0]).slice(0,10),
                        endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.disabledRemove=true
                        this.disabledInfo=true
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            rowClick(row){
                if(this.menuButtonList.indexOf("留样移除")!=-1){
                    this.disabledRemove =false;
                }
                if(this.menuButtonList.indexOf("留样详情")!=-1){
                    this.disabledInfo =false;
                }
                this.checkInfo=row
            }


        }
    }
</script>

<style lang="scss" scoped>
    .dishesCheckRecord /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
    .dishesCheckRecord /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #F5F7FA;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
    }
</style>
